import { appEvents } from "@cayo/shared/components/App/appEvents";
import { bindingsUtils } from "@cayo/shared/scheme/bindings";
import { IActionHandlerParams } from "../types";

export const showAction = (actionId: string, parameters?: IActionHandlerParams) => {
  const parts = actionId.split(",");
  let isBatch = false;
  let template: string | undefined = undefined;
  const prm = parts[1];
  if (parts.length > 1) {
    actionId = parts[0];
    isBatch = prm === "batch";

    if (prm.toLowerCase() === "report") {
      template = prm;
    }
  }

  let actualId: any =
    parameters?.objects && !isBatch
      ? (bindingsUtils.resolveExpression(parameters.objects[0] as any, actionId) as string)
      : actionId;

  if (actualId === false) {
    actualId = actionId;
  }

  appEvents.trigger({
    action: { schemeId: actualId, ...parameters, gridId: parameters?.parentId, template },
  });
};
